import { c as _c } from "react/compiler-runtime";
import { ReferencedNft } from "@/entities/IDrop";
import { ReservoirTokensResponseTokenElement } from "@/entities/IReservoir";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
export default function DropListItemContentNftDetails(t0) {
  const $ = _c(7);
  const {
    referencedNft: t1,
    nft
  } = t0;
  const {
    name: tokenName
  } = t1;
  const image = nft?.token.collection.image;
  let t2;
  if ($[0] !== image) {
    t2 = image && <img alt="Seize" src={getScaledImageUri(image, ImageScale.W_AUTO_H_50)} className="tw-flex-shrink-0 tw-h-4 tw-w-4 tw-object-contain" />;
    $[0] = image;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== tokenName) {
    t3 = <span className="tw-whitespace-nowrap tw-text-sm sm:tw-text-md tw-font-medium tw-text-iron-50">{tokenName}</span>;
    $[2] = tokenName;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <div className="tw-gap-x-2 tw-flex tw-items-center">{t2}{t3}</div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}